import API_LINKS from 'FielderAPILinks';

/**
 *
 * @param {string} filter       - Filter to search the partners by
 * @param {number} idAccount    - Id of the account in use
 * @param {string} idToken      - Login token
 * @param {number} parentAccountId -
 * @param {any} ignoreAssetStatus -
 *
 * @description
 *      Gets all groups by the filter
 * @returns {array} - contains the partners found (returns empty if error)
 */
export const getAssetsByFilter = (filter, idAccount, parentAccountId, idToken, ignoreAssetStatus) => {
	let body = {
		type: 'GET_ASSETS_BY_FILTER_WITH_CATEGORIES', //GET_ASSETS_BY_FILTER
		idAccount: idAccount,
    parentAccountId: parentAccountId != null || parentAccountId > 0 ? parentAccountId : null,
		filter: filter,
		ignoreStatus: ignoreAssetStatus ? ignoreAssetStatus : false,
	};

	return fetch(API_LINKS.functionalityTaskManager, {
		method: 'POST',
		body: JSON.stringify(body),
		headers: {
			'Content-type': 'application/json',
			Authorization: idToken,
		},
	})
		.then((res) => res.json())
		.then((res) => {
			if (res && res.success === true) {
				return res.assets;
			} else {
				console.error(res);
				return [];
			}
		});
};

/**
 *
 * @param {string} filter       - Filter to search the partner by
 * @param {number} idAccount    - Id of the account in use
 * @param {string} idToken      - Login token
 *
 * @description
 *  Gets all partners by the filter send and sets the information and format for the asyncSelect component
 */
export const getAssetsByFilterAsyncSelect = async (
	filter,
	idAccount,
	idToken,
	ignoreAssetStatus,
	lan
) => {
	let assets = await getAssetsByFilter(filter, idAccount, null, idToken, ignoreAssetStatus);
	let assetList = [];

	assets.forEach((asset) => {
		let label = `${asset.id} - ${asset.name}`;
		let assetInfo = [];

		if (asset.category) {
			label += ` [${asset.category.name}]`;
		}

		if (asset.brand) {
			assetInfo.push(asset.brand + ' (' + lan.brand + ')');
		}
		if (asset.type) {
			assetInfo.push(asset.type + ' (' + lan.type + ')');
		}
		if (asset.model) {
			assetInfo.push(asset.model + ' (' + lan.model + ')');
		}
		if (asset.serialNumber) {
			assetInfo.push(asset.serialNumber + ' (' + lan.serialNumber + ')');
		}
		if (asset.contract) {
			assetInfo.push(asset.contract + ' (' + lan.contractNumber + ')');
		}

		label += assetInfo.join(' - ');
		assetList.push({
			label: label,
			value: asset,
		});
	});

	return assetList;
};



export const getAssetsCategoriesByFilter = (filter, idAccount, idToken) => {
	let body = {
		requestType: 'GET_ASSETS_CATEGORIES_BY_FILTER',
		idAccount: idAccount,
		filter: filter
	};

	return fetch(API_LINKS.assetManager, {
		method: 'POST',
		body: JSON.stringify(body),
		headers: {
			'Content-type': 'application/json',
			Authorization: idToken,
		},
	})
		.then((res) => res.json())
		.then((res) => {
			if (res && res.success === true) {
				return res.children;
			} else {
				console.error(res);
				return [];
			}
		});
};



export const getAssetsCategoriesByFilterAsyncSelect = async (
	filter,
	idAccount,
	idToken,
	lan
) => {
	let assets = await getAssetsCategoriesByFilter(filter, idAccount, idToken);
	let assetList = [];

	assets.forEach((asset) => {
		let label = `${asset.id} - ${asset.name}`;
		let assetInfo = [];

		if (asset.category) {
			label += ` [${asset.category.name}]`;
		}

		if (asset.brand) {
			assetInfo.push(asset.brand + ' (' + lan.brand + ')');
		}
		if (asset.type) {
			assetInfo.push(asset.type + ' (' + lan.type + ')');
		}
		if (asset.model) {
			assetInfo.push(asset.model + ' (' + lan.model + ')');
		}
		if (asset.serialNumber) {
			assetInfo.push(asset.serialNumber + ' (' + lan.serialNumber + ')');
		}
		if (asset.contract) {
			assetInfo.push(asset.contract + ' (' + lan.contractNumber + ')');
		}

		label += assetInfo.join(' - ');
		assetList.push({
			label: label,
			value: asset,
		});
	});

	return assetList;
};

export const getAssetsByParentAccountIdFilterAsyncSelect = async (
  filter,
  currentAccountId,
  parentAccountId,
  idToken,
  ignoreAssetStatus,
  lan
) => {
  let assets = await getAssetsByFilter(filter, currentAccountId, parentAccountId, idToken, ignoreAssetStatus);
  let assetList = [];
  assets.forEach((asset) => {
    let label = `${asset.id} - ${asset.name}`;
    let assetInfo = [];
    if (asset.category) label += ` [${asset.category.name}]`;
    if (asset.brand) assetInfo.push(asset.brand + ' (' + lan.brand + ')');
    if (asset.type) assetInfo.push(asset.type + ' (' + lan.type + ')');
    if (asset.model) assetInfo.push(asset.model + ' (' + lan.model + ')');
    if (asset.serialNumber) assetInfo.push(asset.serialNumber + ' (' + lan.serialNumber + ')');
    if (asset.contract) assetInfo.push(asset.contract + ' (' + lan.contractNumber + ')');
    label += assetInfo.join(' - ');
    assetList.push({
      label: label,
      value: asset,
    });
  });
  return assetList;
};
